import { Component } from '@angular/core';

@Component({
    selector: 'app-esi-header',
    template: `<esi-factory-ng view="header"></esi-factory-ng>`,
    standalone: false,
})
export class EsiHeaderComponent {
    constructor() {}
}
